const ZOHO_SCRIPT_ID = "zsiqscript";
const ZOHO_WIDGET_URL =
  "https://salesiq.zohopublic.com/widget?wc=siqbe959fd104a6f61a06968d605b612f690f545fe16eec9bb013d2d13e063ddf89";

const identifyVisitor = (details = {}) => {
  if (!window.$zoho?.salesiq) {
    return;
  }

  const safeCall = (fn) => {
    try {
      fn();
    } catch {
      // Ignore widget errors so they do not affect app rendering.
    }
  };

  safeCall(() => details.name && window.$zoho.salesiq.visitor.name(details.name));
  safeCall(() => details.email && window.$zoho.salesiq.visitor.email(details.email));
  safeCall(
    () => details.phone && window.$zoho.salesiq.visitor.contactnumber(details.phone),
  );
  safeCall(
    () =>
      details.department && window.$zoho.salesiq.chat.department(details.department),
  );
  safeCall(
    () => details.message && window.$zoho.salesiq.visitor.message(details.message),
  );
  safeCall(
    () =>
      details.leadsource && window.$zoho.salesiq.visitor.leadsource(details.leadsource),
  );
  safeCall(
    () =>
      details.utm_campaign &&
      window.$zoho.salesiq.visitor.utm_campaign(details.utm_campaign),
  );
  safeCall(
    () =>
      details.utm_medium && window.$zoho.salesiq.visitor.utm_medium(details.utm_medium),
  );
  safeCall(
    () =>
      details.utm_source && window.$zoho.salesiq.visitor.utm_source(details.utm_source),
  );
  safeCall(
    () => details.utm_term && window.$zoho.salesiq.visitor.utm_term(details.utm_term),
  );
  safeCall(
    () =>
      details.utm_content &&
      window.$zoho.salesiq.visitor.utm_content(details.utm_content),
  );
  safeCall(
    () => details.referrer && window.$zoho.salesiq.visitor.referrer(details.referrer),
  );
  safeCall(
    () => details.website && window.$zoho.salesiq.visitor.website(details.website),
  );
  safeCall(() => details.city && window.$zoho.salesiq.visitor.city(details.city));
  safeCall(() => details.region && window.$zoho.salesiq.visitor.region(details.region));
  safeCall(
    () => details.country && window.$zoho.salesiq.visitor.country(details.country),
  );
  safeCall(
    () => details.zipcode && window.$zoho.salesiq.visitor.zipcode(details.zipcode),
  );
  safeCall(() => details.ip && window.$zoho.salesiq.visitor.ip(details.ip));
  safeCall(
    () => details.browser && window.$zoho.salesiq.visitor.browser(details.browser),
  );
  safeCall(() => details.os && window.$zoho.salesiq.visitor.os(details.os));
  safeCall(
    () => details.device && window.$zoho.salesiq.visitor.device(details.device),
  );
  safeCall(
    () =>
      details.language && window.$zoho.salesiq.visitor.language(details.language),
  );

  if (details.custom && typeof details.custom === "object") {
    Object.entries(details.custom).forEach(([key, value]) => {
      safeCall(() => window.$zoho.salesiq.visitor.custom(key, value));
    });
  }
};

const getStoredVisitorData = () => ({
  name: window.localStorage.getItem("visitor_name"),
  email: window.localStorage.getItem("visitor_email"),
  phone: window.localStorage.getItem("visitor_phone"),
  department: window.localStorage.getItem("visitor_department"),
  message: window.localStorage.getItem("visitor_message"),
  leadsource: window.localStorage.getItem("visitor_leadsource"),
  utm_campaign: window.localStorage.getItem("utm_campaign"),
  utm_medium: window.localStorage.getItem("utm_medium"),
  utm_source: window.localStorage.getItem("utm_source"),
  utm_term: window.localStorage.getItem("utm_term"),
  utm_content: window.localStorage.getItem("utm_content"),
  referrer: document.referrer,
  website: window.location.hostname,
  custom: {},
});

const injectZohoScript = () => {
  if (document.getElementById(ZOHO_SCRIPT_ID)) {
    return;
  }

  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || {
    ready: function ready() {
      window.addEventListener("salesiq.identify", (event) => {
        identifyVisitor(event.detail || {});
      });

      window.setTimeout(() => {
        identifyVisitor(getStoredVisitorData());
      }, 3000);
    },
  };

  const script = document.createElement("script");
  script.id = ZOHO_SCRIPT_ID;
  script.src = ZOHO_WIDGET_URL;
  script.defer = true;
  document.body.appendChild(script);
};

export const initializeZohoSalesIQ = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  const scheduleLoad = () => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(() => {
        window.setTimeout(injectZohoScript, 4000);
      });
      return;
    }

    window.setTimeout(injectZohoScript, 6000);
  };

  if (document.readyState === "complete") {
    scheduleLoad();
    return;
  }

  window.addEventListener("load", scheduleLoad, { once: true });
};
